import { contactCategoryAddApi } from "../../api/contactCategory/contactCategoryAddApi"

type PayloadShape = Parameters<typeof contactCategoryAddApi>[0]

export async function contactCategoryAddService(payload: PayloadShape, token: string) {
	return await contactCategoryAddApi(payload, token)
}
